import fetch from "isomorphic-fetch";
import { message, setIsFetching } from "../actions";
import Configuration from "../config";
import ReactGA from "react-ga";

/**
 * Konstanten
 */
export const SET_ROLES_OVERVIEW = "SET_ROLES_OVERVIEW";
export const SET_PERMISSIONS_OVERVIEW = "SET_PERMISSIONS_OVERVIEW";

/**
 * Setter
 */
export function setRolesOverview( json )
{
	return {
		type: SET_ROLES_OVERVIEW,
		json
	};
}

export function setPermissionsOverview( json )
{
	return {
		type: SET_PERMISSIONS_OVERVIEW,
		json
	};
}

/**
 * Nutzt die Api um die Daten aller Benutzer im Store zu
 */
export function getRolesOverview()
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Roles",
				action: "Berechtigungsübersicht laden"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/roles?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setRolesOverview( json.roles ) );
									dispatch( setPermissionsOverview( json.permissions ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
		
	};
	
} // function getRolesOverview()
